import styled from 'styled-components';
export const Container = styled.div `
  margin-top: var(--space-400);
  color: var(--text-secondary);
  font-size: var(--font-size-100);
  line-height: var(--font-line-height-100);
  letter-spacing: var(--font-letter-spacing-loosest);
`;
